"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PopoverSizes = void 0;
const react_1 = __importStar(require("react"));
const react_2 = require("@headlessui/react");
const outline_1 = require("@heroicons/react/outline");
const elements_ui_components_icon_button_1 = __importDefault(require("@hydrogen/elements.ui.components.icon-button"));
const elements_ui_icon_1 = __importStar(require("@hydrogen/elements.ui.icon"));
const elements_ui_utils_1 = require("@hydrogen/elements.ui.utils");
const react_popper_1 = require("react-popper");
var PopoverSizes;
(function (PopoverSizes) {
    PopoverSizes["small"] = "small";
    PopoverSizes["default"] = "default";
    PopoverSizes["medium"] = "medium";
    PopoverSizes["large"] = "large";
    PopoverSizes["full"] = "full";
    PopoverSizes["auto"] = "auto";
})(PopoverSizes = exports.PopoverSizes || (exports.PopoverSizes = {}));
const Popover = (props) => {
    var _a;
    const [referenceElement, setReferenceElement] = (0, react_1.useState)(null);
    const [popperElement, setPopperElement] = (0, react_1.useState)(null);
    const { styles } = (0, react_popper_1.usePopper)(referenceElement, popperElement, { placement: props.placement });
    const buttonText = props.buttonText || 'More options';
    const buttonContent = props.buttonContent || (react_1.default.createElement(elements_ui_components_icon_button_1.default, { visual: true, size: props.size },
        react_1.default.createElement("span", { className: "sr-only" }, buttonText),
        react_1.default.createElement(elements_ui_icon_1.default, { icon: outline_1.DotsHorizontalIcon, className: "block", size: elements_ui_icon_1.IconsSizes.medium })));
    const size = props.size || 'medium';
    const origin = props.origin || 'right';
    const withRelative = (_a = props.withRelative) !== null && _a !== void 0 ? _a : true;
    return (react_1.default.createElement(react_2.Popover, { className: (0, elements_ui_utils_1.classNames)(withRelative && 'relative', props.classNameWrapper) }, ({ open, close }) => {
        var _a;
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(react_2.Popover.Button, { ref: (e) => setReferenceElement(e), className: (0, elements_ui_utils_1.classNames)(elements_ui_utils_1.globalColorClasses.focus, props.buttonClass), onClick: props.onClick, 'aria-label': props.buttonAreaLabel ? props.buttonAreaLabel : "Toggle button" }, buttonContent),
            react_1.default.createElement(elements_ui_utils_1.TransitionHelper, { show: ((_a = props.open) !== null && _a !== void 0 ? _a : open) && !!props.children, style: props.withPopper ? styles.popper : {}, ref: (e) => setPopperElement(e), raw: props.raw, size: size, origin: origin },
                react_1.default.createElement(react_2.Popover.Panel, { className: props.className }, typeof props.children === 'function' ? props.children({
                    open,
                    close,
                }) : props.children))));
    }));
};
exports.default = Popover;
//# sourceMappingURL=popover.js.map